module.exports = __webpack_public_path__ + "static/seller/img/zl.060ac551.png";